const TASBIH_DATA = [
  {
    id: 1,
    tittleAR: "سبحان الله",
    tittleEN: "SubhanAllah",
    tittleBN: "সুবহানাল্লাহ্‌",
    transBN: "সব গৌরব একমাত্র আল্লাহর",
    count: 0,
    isSubmitDisabled: false,
  },
  {
    id: 2,
    tittleAR: "الحمد لله",
    tittleEN: "Alhamdulillah",
    tittleBN: "আলহামদুলিল্লাহ্‌",
    transBN: "সকল প্রশংসা মহান আল্লাহ্‌ তায়ালার জন্য",
    count: 0,
    isSubmitDisabled: false,
  },
  {
    id: 3,
    tittleAR: "الله أكبر",
    tittleEN: "Allah Hu Akbar",
    tittleBN: "আল্লহু আকবর",
    transBN: "আল্লাহ্‌ মহান",
    count: 0,
    isSubmitDisabled: false,
  },
  // {
  //   tittleAR: "",
  //   tittleEN: "",
  //   tittleBN: "",
  // transBN: "",
  //   count: "0",
  // isSubmitDisabled: false,
  // },
];

export default TASBIH_DATA;
